import { render, staticRenderFns } from "./TutorialRedirectModal.vue?vue&type=template&id=0b5fde6e&scoped=true&"
import script from "./TutorialRedirectModal.vue?vue&type=script&lang=js&"
export * from "./TutorialRedirectModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorialRedirectModal.vue?vue&type=style&index=0&id=0b5fde6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5fde6e",
  null
  
)

export default component.exports